import script from "./VBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./VBarChart.vue?vue&type=script&lang=ts&setup=true"

import "./VBarChart.vue?vue&type=style&index=0&id=777bc2dc&lang=sass"

const __exports__ = script;

export default __exports__